// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"555e3246","239":"a41cc0a0","732":"423c70e7"}[chunkId] + ".chunk.js";
};